import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue'
import { useI18n } from 'vue-i18n'


export default /*#__PURE__*/_defineComponent({
  props: {
  tooltip: {
    type: String,
    default: undefined,
  },
  tooltipLeft: {
    type: String,
    default: undefined,
  },
  tooltipRight: {
    type: String,
    default: undefined,
  },
},
  setup(__props) {

const props = __props

const { t } = useI18n()



const computedTooltip = computed(() => {
  if (props.tooltip) {
    return {
      tooltip: props.tooltip,
    }
  } else if (props.tooltipRight) {
    return {
      tooltipRight: props.tooltipRight,
    }
  } else if (props.tooltipLeft) {
    return {
      tooltipLeft: props.tooltipLeft,
    }
  }

  // Default is just "delete" to the left
  return {
    tooltipLeft: t('inri.common.delete'),
  }
})

return (_ctx: any,_cache: any) => {
  const _component_c_tile_btn = _resolveComponent("c-tile-btn")!

  return (_openBlock(), _createBlock(_component_c_tile_btn, _mergeProps({ "data-id": "delete-btn" }, _unref(computedTooltip), {
    icon: "mdi-delete-outline",
    "slide-effect-color": "red-light",
    "icon-size": "20"
  }), null, 16))
}
}

})